import { createApi } from "@reduxjs/toolkit/query/react"
import { ContractDto, ContractsDto, GetContractsQueryParams } from "@custom-types/contract"
import { authQuery } from "./authQuery"

export const contractsApi = createApi({
  reducerPath: "contractsApi",
  baseQuery: authQuery,
  tagTypes: ["Contracts"],
  endpoints: (builder) => ({
    getContracts: builder.query<ContractsDto, GetContractsQueryParams>({
      query: ({ organisation_key = undefined, division_key = undefined }) => ({
        url: "/contracts",
        params: {
          organisation_key,
          division_key,
        },
      }),
      providesTags: ["Contracts"],
    }),
    getContractByKey: builder.query<ContractDto, string>({
      query: (key) => ({
        url: `/contracts/${key}`,
      }),
      providesTags: ["Contracts"],
    }),
    createContract: builder.mutation<ContractDto, ContractDto>({
      query: (contract) => ({
        url: "/contracts",
        method: "POST",
        body: contract,
      }),
      invalidatesTags: ["Contracts"],
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
    updateContract: builder.mutation<ContractDto, { key: string; data: any }>({
      query: (param) => ({
        url: `/contracts/${param.key}`,
        method: "PUT",
        body: param.data,
      }),
      invalidatesTags: ["Contracts"],
    }),
  }),
})

export const {
  useGetContractsQuery,
  useCreateContractMutation,
  useLazyGetContractByKeyQuery,
  useUpdateContractMutation,
} = contractsApi
